import { apiSlice } from "../../../../app/service/Service";


export const useScoreSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        score: builder.mutation({
            query : (body)=> ({
                    url: `GameScore/InsertGameScore`,
                    method: "POST",
                    body
            })
        }), 
        
        getScore: builder.query({
            query : (roomId)=> ({
                    url: `GameScore/GetGameScore?RoomId=${roomId}`,
                    method: "GET",
                    
            })
        }),
        viewScore: builder.query({
            query : (roomId)=> ({
                    url: `GameScore/GetGameScore?RoomId=79B45400-E6FC-4474-98DB-27DB36C661C0`,
                    method: "GET",
                    
            })
        }),
    })
})

export const { useScoreMutation , useLazyGetScoreQuery ,useViewScoreQuery } = apiSlice;
